import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";
import { Link } from "react-router-dom";

function WsSessionStatus(props) {
  const { wsException } = props;

  if (wsException !== 401) {
    return null;
  }

  return (
    <Alert variant="warning" className="ws-session-status">
      <i className="fa fa-warning" />
      <span className="ws-session-status-text">
        Your session has expired. Please <Link to="/logout">log in</Link>.
      </span>
    </Alert>
  );
}

WsSessionStatus.propTypes = {
  wsException: PropTypes.number,
};

export { WsSessionStatus };
